import React, { useState } from "react";
import CustomInput from "../CustomInput/CustomInput";
import { EFormId, EInputType } from "../../interfaces/enum";
import classNames from "classnames";
import Button from "../Button/Button";
import RedirectLink from "../RedirectLink/RedirectLink";
import styles from "./Form.module.scss";
import { FormProps } from "./FormProps";
import { FormResponse, createAccount, loginAccount } from "../../utils/login";
import { ERoute } from "../../routes/routes";
import { useNavigate } from "react-router-dom";

export type FormType = {
  text: string;
  password: string;
  retypePassword: string;
};

const Form = ({ data, isSignup, setIsLoading, isLoading }: FormProps) => {
  const initialForm: FormType = {
    text: "",
    password: "",
    retypePassword: "",
  };

  const [form, setForm] = useState<FormType>(initialForm);
  const navigate = useNavigate();

  const isDisabled = (): boolean => {
    if (form == null) return true;
    let notDisable = false;
    if (isSignup) {
      notDisable =
        form?.text?.length !== 0 &&
        form?.password?.length !== 0 &&
        form?.retypePassword?.length !== 0 &&
        form.retypePassword === form.password;
    } else {
      notDisable = form?.text?.length !== 0 && form?.password?.length !== 0;
    }
    return !notDisable;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      } as FormType;
    });
  };

  const handleClick = async () => {
    if (isLoading) return;
    setIsLoading(true);
    try {
      const prom = isSignup
        ? await createAccount(form)
        : await loginAccount(form.text, form.password);
      if (!prom.ok) {
        return;
      }
      navigate(isSignup ? ERoute.LOGIN : ERoute.DASHBOARD);
    } catch (err) {
      console.error((err as any as FormResponse).message);
      setIsLoading(false);
    }
  };

  return (
    <div className={classNames(styles.form)}>
      <h1 className={classNames(styles.title)}>
        {isSignup ? data.label.signup : data.label.login}
      </h1>
      <div className="d-flex flex-column gap-4">
        <CustomInput
          value={form?.text || ""}
          id={EFormId.USERNAME}
          setValue={handleChange}
          inputType={EInputType.TEXT}
          placeholder={data.placeholders.email}
          errorMessage={data.errors.email}
        />
        <CustomInput
          value={form?.password || ""}
          id={EFormId.PASSWORD}
          setValue={handleChange}
          inputType={EInputType.PASSWORD}
          placeholder={data.placeholders.password}
          errorMessage={data.errors.password}
          onClickEnter={!isSignup && !isDisabled() ? handleClick : undefined}
        />
        {isSignup && (
          <CustomInput
            value={form?.retypePassword || ""}
            id={EFormId.RETYPE}
            setValue={handleChange}
            inputType={EInputType.RETYPE_PW}
            placeholder={data.placeholders.repeatPassword!!}
            errorMessage={data.errors.repeatPassword}
            onClickEnter={isSignup && !isDisabled() ? handleClick : undefined}
          />
        )}
        <Button
          value={isSignup ? data.label.button.signup : data.label.button.login}
          onClick={handleClick}
          isDisabled={isDisabled()}
        />
        <RedirectLink
          data={isSignup ? data.changePage.signup : data.changePage.login}
        />
      </div>
    </div>
  );
};

export default Form;
